const { Core, Utils, Events } = Global;
const { $hide, $show } = Utils;

customElements.define('product-purchase-limit', class extends Core {
    elements = {
        $: ['note', 'error']
    }

    propTypes = {
        'product-id': Number
    }

    render() {
        this.sub(Events.PURCHASE_LIMIT_BLOCKED, this._blockedHandler, { global: true });
        this.sub(Events.CART_UPDATE, this._resetHandler, { global: true });
    }

    _blockedHandler({ productId }) {
        if (productId !== this.prop('product-id')) {
            return;
        }
        $hide(this.$('note'));
        $show(this.$('error'));
    }

    _resetHandler() {
        $show(this.$('note'));
        $hide(this.$('error'));
    }
})
